/* 12K Carbon theme — behaviour. No dependencies. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = window.theme && window.theme.money ? window.theme.money : { format: '£{{amount}}' };
  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    return money.format.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  window.theme = window.theme || {};
  window.theme.fmt = fmt;

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.setAttribute('open', ''); d.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden';
    var f = $('[data-autofocus]', d) || $('.drawer__close', d); if (f) f.focus();
  }
  function closeDrawers() {
    $$('.drawer[open]').forEach(function (d) { d.removeAttribute('open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer__scrim')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  window.theme.openDrawer = openDrawer;

  /* ---------- cart ---------- */
  function swapSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key]; if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-section="' + key + '"]');
      var old = document.querySelector('[data-section="' + key + '"]');
      if (fresh && old) old.replaceWith(fresh);
    });
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; });
  }
  window.theme.addToCart = function (items, opts) {
    opts = opts || {};
    return cartRequest('/cart/add.js', { items: items }).then(function (res) {
      swapSections(res.sections);
      return refreshCart().then(function () { if (!opts.silent) openDrawer('cart-drawer'); return res; });
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (b) {
      var line = b.closest('[data-line]'); var input = $('input[name="quantity"]', line);
      var q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(b.getAttribute('data-qty-change'), 10));
      changeLine(line.getAttribute('data-line'), q); return;
    }
    var r = e.target.closest('[data-line-remove]');
    if (r) { e.preventDefault(); changeLine(r.closest('[data-line]').getAttribute('data-line'), 0); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line] input[name="quantity"]')) {
      changeLine(e.target.closest('[data-line]').getAttribute('data-line'), parseInt(e.target.value || '0', 10));
    }
  });
  function changeLine(line, quantity) {
    var root = $('[data-section="cart-drawer"]'); if (root) root.style.opacity = '.5';
    cartRequest('/cart/change.js', { line: parseInt(line, 10), quantity: quantity }).then(function (res) {
      swapSections(res.sections); updateCount(res.item_count);
      var page = $('[data-cart-page]'); if (page) window.location.reload();
    }).catch(function () { if (root) root.style.opacity = ''; });
  }

  /* ---------- product form ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var root = form.closest('[data-product]');
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var bundleEl = $('[data-bundle-json]', root);
    var bundle = bundleEl ? JSON.parse(bundleEl.textContent) : null;
    var racketOpt = root.getAttribute('data-bundle-option');
    var racketVal = root.getAttribute('data-bundle-value');
    var idInput = $('input[name="id"]', form);
    var priceNow = $('[data-price]', root), priceWas = $('[data-compare]', root);
    var stickPrice = $('[data-stick-price]'), stickName = $('[data-stick-name]'), stickBase = stickName ? stickName.getAttribute('data-base') : '';
    var atc = $('[data-atc]', form), atcLabel = $('[data-atc-label]', form);
    var atcBase = atcLabel ? atcLabel.textContent : 'Add to bag';
    var mode = 'single';
    var current = null;

    function setPrice(v) {
      priceNow.textContent = fmt(v.price);
      if (priceWas) { if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = fmt(v.compare_at_price); priceWas.hidden = false; } else { priceWas.hidden = true; } }
      if (stickPrice) stickPrice.textContent = fmt(v.price);
      $$('[data-pay-in-3]', root).forEach(function (el) { el.textContent = fmt(Math.round(v.price / 3)); });
    }
    function setAvailability(v) {
      var ok = !!(v && v.available);
      atc.disabled = !ok;
      atcLabel.textContent = ok ? atcBase + (mode === 'bundle' ? ' · ' + (root.getAttribute('data-bundle-label') || 'Pack') : '') : 'Sold out';
      var sb = $('[data-stick-atc]'); if (sb) sb.disabled = !ok;
      if (stickName) stickName.textContent = stickBase + ' · ' + (mode === 'bundle' ? (root.getAttribute('data-bundle-label') || 'Pack') : (root.getAttribute('data-single-label') || 'Racket only'));
    }
    var stage = $('[data-stage]', root);
    function showMedia(m) {
      if (!stage || !m) return;
      var img = $('img', stage); if (!img) return;
      var src = (m.preview_image && m.preview_image.src) || m.src; if (!src) return;
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      img.srcset = [600, 900, 1200, 1400].map(function (w) { return src + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      img.src = src + sep + 'width=1200';
      stage.setAttribute('data-media-id', m.id);
    }
    function selectVariant(v) {
      current = v; if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id; setPrice(v); setAvailability(v);
      if (stage) { showMedia(v.featured_media); var nm = $('[data-sw-name]', root), ck = $('.gsw input:checked', root); if (nm && ck) nm.textContent = ck.value; }
      if (!stage && mode === 'single' && v.featured_media) {
        var fig = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (fig) { $$('.gallery figure', root).forEach(function (f) { f.classList.remove('is-active'); }); fig.classList.add('is-active'); if (window.innerWidth < 821) fig.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); }
      }
    }
    function selectedValues(scope) {
      return $$('fieldset', scope).map(function (fs) {
        var checked = $('input:checked', fs); if (checked) return checked.value;
        var sel = $('select', fs); return sel ? sel.value : null;
      });
    }
    function findVariant(product, values, fixed) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) {
          if (fixed && fixed.index === i) return o === fixed.value;
          return o === values[i];
        });
      });
    }
    /* single product picker */
    var picker = $('[data-picker]', root);
    function resolveSingle() {
      var values = picker ? selectedValues(picker) : [];
      var v = picker ? findVariant(data, values) : data.variants[0];
      selectVariant(v || null);
      if (picker) {
        /* mark unavailable pills relative to other selections */
        $$('fieldset', picker).forEach(function (fs, idx) {
          $$('.pill', fs).forEach(function (pill) {
            var val = $('input', pill).value;
            var test = values.slice(); test[idx] = val;
            var m = findVariant(data, test);
            pill.classList.toggle('is-unavailable', !(m && m.available));
          });
        });
      }
    }
    if (picker) picker.addEventListener('change', function () { if (mode === 'single') resolveSingle(); });
    if (picker && stage) {
      $$('.gsw', picker).forEach(function (l) {
        l.addEventListener('mouseenter', function () {
          var fs = l.closest('fieldset'); var idx = $$('fieldset', picker).indexOf(fs);
          var vals = selectedValues(picker); vals[idx] = $('input', l).value;
          var m = findVariant(data, vals); if (m && m.featured_media) showMedia(m.featured_media);
          var nm = $('[data-sw-name]', root); if (nm) nm.textContent = $('input', l).value;
        });
        l.addEventListener('mouseleave', function () {
          if (current && current.featured_media) showMedia(current.featured_media);
          var nm = $('[data-sw-name]', root), ck = $('.gsw input:checked', root); if (nm && ck) nm.textContent = ck.value;
        });
      });
    }

    /* bundle toggle */
    var bundlePicker = $('[data-bundle-picker]', root);
    var fixedIndex = -1;
    if (bundle && racketOpt) {
      fixedIndex = bundle.options.map(function (o) { return o.name.toLowerCase(); }).indexOf(racketOpt.toLowerCase());
      var pool = bundle.variants.filter(function (v) { return fixedIndex < 0 || v.options[fixedIndex] === racketVal; });
      /* build selects for the other options, limited to values that exist for this racket */
      bundle.options.forEach(function (opt, i) {
        if (i === fixedIndex) return;
        var vals = []; pool.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
        var fs = document.createElement('fieldset'); fs.innerHTML = '<legend>' + opt.name + '</legend>';
        var sel = document.createElement('select'); sel.className = 'select'; sel.name = 'bundle-' + i;
        vals.forEach(function (val) { var o = document.createElement('option'); o.value = val; o.textContent = val; sel.appendChild(o); });
        fs.appendChild(sel); bundlePicker.appendChild(fs);
      });
      bundlePicker.addEventListener('change', function () { if (mode === 'bundle') resolveBundle(); });
    }
    function resolveBundle() {
      var values = selectedValues(bundlePicker);
      /* values array skips the fixed option; rebuild full order */
      var full = []; var k = 0;
      bundle.options.forEach(function (o, i) { full[i] = (i === fixedIndex) ? racketVal : values[k++]; });
      var v = findVariant(bundle, full);
      selectVariant(v || null);
    }
    $$('input[name="purchase-mode"]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        mode = r.value;
        if (bundlePicker) bundlePicker.hidden = mode !== 'bundle';
        if (mode === 'bundle') resolveBundle(); else resolveSingle();
      });
    });
    resolveSingle();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      var qty = parseInt(($('input[name="quantity"]', form) || { value: 1 }).value, 10) || 1;
      atc.classList.add('is-loading'); var t = atcLabel.textContent; atcLabel.textContent = 'Adding…';
      window.theme.addToCart([{ id: current.id, quantity: qty }]).then(function () {
        atcLabel.textContent = 'Added ✓'; setTimeout(function () { atcLabel.textContent = t; atc.classList.remove('is-loading'); }, 1400);
      }).catch(function (err) {
        atcLabel.textContent = (err && err.description) || 'Could not add'; setTimeout(function () { atcLabel.textContent = t; atc.classList.remove('is-loading'); }, 2200);
      });
    });
    var stickBtn = $('[data-stick-atc]');
    if (stickBtn) stickBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });

    /* sticky bar visibility: show once main ATC scrolls out */
    var stick = $('[data-stick]');
    if (stick && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { stick.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(atc);
    }
  });

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); var t = b.textContent; b.textContent = 'Adding…';
    window.theme.addToCart([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }]).then(function () { b.textContent = t; }).catch(function () { b.textContent = t; });
  });

  /* ---------- cart upsell variant select ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-variant-select]')) return;
    var item = e.target.closest('[data-up-item]'); var b = item && item.querySelector('[data-quick-add]');
    if (b) b.setAttribute('data-quick-add', e.target.value);
    var opt = e.target.selectedOptions[0], price = item && item.querySelector('.cart-up__price');
    if (opt && price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
  });

  /* ---------- collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); });

  /* ---------- hero video autoplay guard ---------- */
  $$('video[autoplay]').forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
})();
